export default {
  message: {
    "strid1": "Inicio",
    "strid2": "Tutorial",
    "strid3": "Evento",
    "strid4": "Únete",
    "strid5": "Discord",
    "strid6": "Academia de Creadores",
    "strid7": "Trabajos Seleccionados",
    "strid8": "Atrás",
    "strid9": "Participa Ahora",
    "strid10": "Más Eventos",
    "strid11": "Información Personal",
    "strid12": "Servidor del Juego",
    "strid13": "Ingresa tu Servidor",
    "strid14": "ID del Juego",
    "strid15": "Ingresa tu ID del juego",
    "strid16": "Datos de Contacto",
    "strid17": "Selecciona Plataforma",
    "strid18": "Ingresa tu información de contacto",
    "strid19": "Detalles del Trabajo",
    "strid20": "Plataforma de Publicación",
    "strid21": "Ingresa un enlace correcto",
    "strid22": "Toca para agregar un nuevo enlace",
    "strid23": "Idioma Utilizado",
    "strid24": "Selecciona el idioma utilizado",
    "strid25": "Inglés",
    "strid26": "Árabe",
    "strid27": "Español",
    "strid28": "Portugués",
    "strid29": "Jemer",
    "strid30": "Birmano",
    "strid31": "Malayo",
    "strid32": "Otro",
    "strid33": "Confirmo la propiedad del trabajo y reconozco este acuerdo",
    "strid34": "Enviar",
    "strid35": "¡Enviado!",
    "strid36": "Beneficios",
    "strid37": "Únetenos ahora para obtener",
    "strid38": "Apoyo de las redes sociales oficiales de MLBB",
    "strid39": "Comunidad interactiva de los creadores",
    "strid40": "Recompensa Semanal de Diamantes",
    "strid41": "Más beneficios para desbloquear",
    "strid42": "Mercancía del Juego",
    "strid43": "Eventos Offline",
    "strid44": "Toneladas de Apariencias",
    "strid45": "Marcas colaboradoras",
    "strid46": "Promoción de Anuncios",
    "strid47": "ÚNETENOS",
    "strid48": "Requisitos",
    "strid49": "SÍGUENOS",
    "strid50": "Toque para comprobar la cuenta oficial de MLBB",
    "strid51": "Contenido del Acuerdo",
    "strid52": "Por favor completa la información",
    "strid53": "Envío fallido",
    "strid54": "Por favor completa el enlace correcto de tu canal",  // 请输入正确的频道链接
    "strid55": "Selecciona tu región",
    "strid56": "Tu Región",


  }
}
